import { NEW_HOST_URL } from "../../config/envConfig";
import { fetch } from "../../utils";

export const getAllOrganizations = async () => {
  return fetch(`${NEW_HOST_URL}/organizations/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getOrganizationsCount = async () => {
  return fetch(`${NEW_HOST_URL}/organizations/count`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const createOrganization = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const createOrganizationWorkspace = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/workspace`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      name: data?.name,
      logo: data?.logo,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAllOrganizationWorkspaces = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/workspace/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const createOrganizationUser = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      name: data?.name,
      photo: data?.photo,
      email: data?.email,
      password: data?.password,
      role: data?.role,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getOrganizations = async (data) => {
  //fromDate=${data?.fromDate}&toDate=${data?.toDate}
  return fetch(
    `${NEW_HOST_URL}/organizations?page=${data?.page}&pageSize=${data?.pageSize}&searchQuery=${data?.search}&organizationId=${data?.organizationId || ""}&fromDate=${data?.fromDate || ""}&toDate=${data?.toDate || ""}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const editOrganization = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      name: data?.name,
      logo: data?.logo,
      planId: data?.planId,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getOrganizationAssignableUsers = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/users/assignable`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const assignOrganizationUser = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/user/${data?.userId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      role: data?.role,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const deleteOrganization = async (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getOrganizationWorkspaces = async (data) => {
  //fromDate=${data?.fromDate}&toDate=${data?.toDate}
  return fetch(
    `${NEW_HOST_URL}/organization/${data?.organizationId}/workspaces?page=${data?.page}&pageSize=${data?.pageSize}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getOrganizationUsers = async (data) => {
  //fromDate=${data?.fromDate}&toDate=${data?.toDate}
  let roles = data?.roles ? JSON.stringify(data.roles) : "";
  let query = `?page=${data?.page}&pageSize=${data?.pageSize}&role=${data?.role || ""}&roleType=${data?.roleType || ""}&searchQuery=${data?.search || ""}&fromDate=${data?.fromDate || ""}&toDate=${data?.toDate || ""}&roles=${roles}`;
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/users${query}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getOrganizationDetails = async (data) => {
  return fetch(`${NEW_HOST_URL}/organizations/${data?.entityId}?getConfig=${data?.getConfig || false}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const downloadOrganizationCSV = async (data) => {
  return fetch(`${NEW_HOST_URL}/export_organization_report_csv`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      data,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
